"use client";

import dynamic from "next/dynamic";

const Receipt = dynamic(() => import("./receipt-explorer"));
const Context = dynamic(() => import("./context-explorer"));
const Gates = dynamic(() => import("./gates-explorer"));
const Interfaces = dynamic(() => import("./interfaces-explorer"));

export function Explainer({ kind }: { kind: string }) {
  switch (kind) {
    case "receipt":
      return <Receipt />;
    case "context":
      return <Context />;
    case "gates":
      return <Gates />;
    case "interfaces":
      return <Interfaces />;
    default:
      throw new Error(`Unknown article explainer: ${kind}`);
  }
}
